// extracted by mini-css-extract-plugin
export default {"text":"pageContact_text__E6jdD"};